import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import colors from "../../theme/color/ColorTheme";
import fontSize from "../../theme/fonts/FontTheme";

const Wrapper = styled.div`
  max-width: 100%;
  background-color: white;
  padding: 32px 40px;
  display: flex;
  justify-content: space-between;
`;

const Container = styled.div`
  display: flex;
  gap: 50px;
`;

const Columns = styled.div``;

const List = styled.ul`
  display: flex;
  gap: 20px;
  padding-left: 0;
  max-width: 180px;
  flex-direction: column;
  span {
    color: ${colors.black};
    letter-spacing: 0.12rem;
    font-size: ${fontSize.s};
    line-height: 1.2rem;
  }

  li {
    padding: 0;
    list-style: none;
    cursor: pointer;
    letter-spacing: 0.08rem;
    font-size: ${fontSize.xxs};
    color: ${colors.primaryGray};
    &:hover {
      text-decoration: underline;
      text-underline-offset: 2px;
    }
  }
`;

const CardWrapper = styled.div`
  display: flex;
  gap: 12px;
`;

const Card = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
`;

const ImageWrapper = styled.div`
  position: relative;
  width: clamp(200px, 25vw, 300px);
  aspect-ratio: 4 / 4;
  overflow: hidden;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;

    &:hover {
      transform: scale(1.05);
    }
  }

  @media (max-width: 700px) {
    width: 100%;
    max-width: 360px;
    margin: 0 auto;
  }
`;

const Title = styled.span`
  position: absolute;
  bottom: 20px;
  left: 20px;
  font-size: ${fontSize.m};
  color: #fff;
  z-index: 12;
`;

function ScarvesMegaMenu() {
  const navigate = useNavigate();

  return (
    <Wrapper>
      <Container>
        <Columns>
          <List>
            <span>SCARVES & ACCESSORIES</span>
            <li>All Scarves & Accessories</li>
            <li>Scarves</li>
            <li>Shawls</li>
            <li>Wraps</li>
          </List>
        </Columns>
        <Columns>
          <List>
            <span>BY WEIGHT</span>
            <li>Warm</li>
            <li>Temperate</li>
            <li>Light</li>
          </List>
        </Columns>
        <Columns>
          <List>
            <span>BY COLOR</span>
            <li>Natural Yak white</li>
            <li>Grey & natural Yak grey</li>
            <li>Brown & natural Yak brown</li>
            <li>Black</li>
          </List>
        </Columns>
      </Container>
      <CardWrapper>
        <Card
          onClick={() => {
            navigate("/browse");
          }}
        >
          <ImageWrapper>
            <img
              src={
                "https://www.norlha.com/cdn/shop/files/03_PrinceLight_GoldBrown_03_370x230@2x.jpg?v=1757187158"
              }
              alt="end of season"
            />
            <Title>DISCOVER MORE</Title>
          </ImageWrapper>
        </Card>
        <Card
          onClick={() => {
            navigate("/browse");
          }}
        >
          <ImageWrapper>
            <img
              src="https://www.norlha.com/cdn/shop/files/ShepherdJacket_NaturalYakGrey_07_1000x.jpg?v=1756427558"
              alt="ready to wear"
            />
            <Title>READY TO WEAR</Title>
          </ImageWrapper>
        </Card>
      </CardWrapper>
    </Wrapper>
  );
}

export default ScarvesMegaMenu;
